// Keeps the "Color: <name>" label in sync with the selected swatch.
// Variant selection itself is handled by the theme's <variant-radios> element.
if (!window.swatchLabelListener) {
  window.swatchLabelListener = true;

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

    const fieldset = input.closest('.product-form__input--swatch');
    if (!fieldset) return;

    const selectedValue = fieldset.querySelector('.swatch-selected-value');
    if (selectedValue) selectedValue.textContent = input.value;
  });
}
